import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined"
import { Button, Grid, Popover, Typography } from "@mui/material"
import { ChangeEvent, useCallback, useEffect, useState } from "react"
import "react-date-range/dist/styles.css" // main css file
import "react-date-range/dist/theme/default.css"

import { useTranslation } from "react-i18next"
import BankAutoComplete from "./bank-autocomplete"

interface IFiltersCorporateProps {
	filterBank: string | undefined
	setFilterBank: (bank: string | undefined) => void
	autoAcceptFilter: boolean | undefined
	setAutoAcceptFilter: (value: boolean | undefined) => void
	checkIbanFilter: boolean | undefined
	setCheckIbanFilter: (value: boolean | undefined) => void
	handleSearch: () => void
	whatsappFilter: boolean | undefined
	setWhatsappFilter: (value: boolean | undefined) => void
}

const FiltersCorporate = ({
	filterBank,
	setFilterBank,
	autoAcceptFilter,
	setAutoAcceptFilter,
	checkIbanFilter,
	setCheckIbanFilter,
	handleSearch,
	whatsappFilter,
	setWhatsappFilter,
}: IFiltersCorporateProps) => {
	const { t } = useTranslation()
	const [anchorEl, setAnchorEl] = useState(null)
	const [filtersCount, setFiltersCount] = useState<number>(0)
	const [whatsappRadioValue, setWhatsappRadioValue] = useState<
		string | undefined
	>(whatsappFilter)
	const [autoAcceptRadioValue, setAutoAcceptRadioValue] = useState<
		string | undefined
	>(autoAcceptFilter)
	const [checkIbanRadioValue, setCheckIbanRadioValue] = useState<
		string | undefined
	>(checkIbanFilter)

	useEffect(() => {
		let count: number = 0

		if (filterBank) count++

		setFiltersCount(count)
	}, [filterBank])

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const open = Boolean(anchorEl)

	const handleChangeWhatsApp = useCallback(
		(event: ChangeEvent) => {
			setWhatsappRadioValue(
				whatsappRadioValue === event.target.name ? undefined : event.target.name
			)
			setWhatsappFilter(
				whatsappRadioValue === event.target.name
					? undefined
					: event.target.name === "whatsappOn"
						? true
						: false
			)
		},
		[whatsappRadioValue]
	)

	const handleChangeAutoAccept = (event: ChangeEvent) => {
		setAutoAcceptRadioValue(
			autoAcceptRadioValue === event.target.name ? undefined : event.target.name
		)
		setAutoAcceptFilter(
			autoAcceptRadioValue === event.target.name
				? undefined
				: event.target.name === "autoAcceptOn"
					? true
					: false
		)
	}

	const handleChangeCheckIban = (event: ChangeEvent) => {
		setCheckIbanRadioValue(
			checkIbanRadioValue === event.target.name ? undefined : event.target.name
		)
		setCheckIbanFilter(
			checkIbanRadioValue === event.target.name
				? undefined
				: event.target.name === "checkIbanOn"
					? true
					: false
		)
	}

	const resetFilter = () => {}

	return (
		<div>
			<Button variant="outlined" onClick={handleClick}>
				<FilterAltOutlinedIcon />
				<Typography variant="subtitle2" style={{ textTransform: "capitalize" }}>
					{t("filter.label", { ns: "corporate" })}
				</Typography>
				<Typography
					component="span"
					variant="caption"
					style={{ textTransform: "lowercase" }}
				>
					({filtersCount})
				</Typography>
			</Button>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				transformOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<Grid
					container
					gap={"16px"}
					sx={{ padding: "32px", width: "550px", maxWidth: "90vw" }}
				>
					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						style={{ maxWidth: "230px", width: "100%" }}
					>
						<BankAutoComplete
							disableClearable={true}
							filterBank={filterBank}
							setFilterBank={setFilterBank}
						/>
					</Grid>
					{/* TODO evaluate for new release
					<Grid item xs={12} sm={12} md={6} style={{ maxWidth: "230px" }}>
						<FormGroup>
							{" "}
							<FormControlLabel
								control={
									<Checkbox
										checked={whatsappRadioValue === "whatsappOn"}
										onChange={handleChangeWhatsApp}
										name="whatsappOn"
									/>
								}
								label="Whatsapp ON"
							/>
							<FormControlLabel
								control={
									<Checkbox
										checked={whatsappRadioValue === "whatsappOff"}
										onChange={handleChangeWhatsApp}
										name="whatsappOff"
									/>
								}
								label="Whatsapp OFF"
							/>{" "}
						</FormGroup>
					</Grid>
					<Grid item xs={12} sm={12} md={6} style={{ maxWidth: "230px" }}>
						<FormGroup>
							{" "}
							<FormControlLabel
								control={
									<Checkbox
										checked={autoAcceptRadioValue === "autoAcceptOn"}
										onChange={handleChangeAutoAccept}
										name="autoAcceptOn"
									/>
								}
								label="Auto Accettazione ON"
							/>
							<FormControlLabel
								control={
									<Checkbox
										checked={autoAcceptRadioValue === "autoAcceptOff"}
										onChange={handleChangeAutoAccept}
										name="autoAcceptOff"
									/>
								}
								label="Auto Accettazione OFF"
							/>{" "}
						</FormGroup>
					</Grid>
					<Grid item xs={12} sm={12} md={6} style={{ maxWidth: "230px" }}>
						<FormGroup>
							{" "}
							<FormControlLabel
								control={
									<Checkbox
										checked={checkIbanRadioValue === "checkIbanOn"}
										onChange={handleChangeCheckIban}
										name="checkIbanOn"
									/>
								}
								label="Check Iban ON"
							/>
							<FormControlLabel
								control={
									<Checkbox
										checked={autoAcceptRadioValue === "checkIbanOff"}
										onChange={handleChangeCheckIban}
										name="checkIbanOff"
									/>
								}
								label="Check Iban OFF"
							/>{" "}
						</FormGroup>
					</Grid> */}
				</Grid>
				<Grid
					container
					justifyContent={"space-between"}
					alignItems={"center"}
					sx={{ backgroundColor: "#F1F1F1", padding: "0 16px" }}
				>
					<Grid item sx={{ width: "calc(50% - 32px)", padding: "16px 0" }}>
						<Button
							sx={{ width: "100%", marginLeft: "16px" }}
							variant="outlined"
							onClick={resetFilter}
						>
							{t("filter.buttons.cancel", { ns: "corporate" })}
						</Button>
					</Grid>
					<Grid item sx={{ width: "calc(50% - 32px)", padding: "16px 0" }}>
						<Button
							variant="contained"
							onClick={() => {
								handleSearch()
								setAnchorEl(null)
							}}
							style={{ width: "100%", marginRight: "16px" }}
						>
							{t("filter.buttons.send", { ns: "corporate" })}
						</Button>
					</Grid>
				</Grid>
			</Popover>
		</div>
	)
}

export default FiltersCorporate
